import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { Network } from "lucide-react";
import ChartCanvas from "@/components/chart/ChartCanvas";
import OutlineView from "@/components/chart/OutlineView";
import TeamGrid from "@/components/chart/TeamGrid";
import Legend from "@/components/chart/Legend";

export default function ShareViewPage() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [collapsed, setCollapsed] = useState(new Set());
  const [layout, setLayout] = useState("classic");

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/share/${token}`)
      .then((r) => { setData(r.data); setLayout(r.data.view.default_layout || "classic"); })
      .catch((e) => setError(e.response?.data?.detail || "Link unavailable"));
  }, [token]);

  if (error)
    return (
      <div className="h-screen flex flex-col items-center justify-center gap-3 text-center p-8">
        <Network size={40} className="text-[#C4C7D4]" />
        <h2 className="text-2xl font-black tracking-tight">Link unavailable</h2>
        <p className="text-[#676a82] font-medium">{error}</p>
      </div>
    );
  if (!data)
    return <div className="h-screen flex items-center justify-center"><div className="w-10 h-10 rounded-full border-4 border-[#6161FF] border-t-transparent animate-spin" /></div>;

  const { view, employees, org_name } = data;
  const onToggle = (id) => setCollapsed((prev) => { const n = new Set(prev); n.has(id) ? n.delete(id) : n.add(id); return n; });

  return (
    <div className="h-screen flex flex-col bg-[#F6F7FB]" data-testid="share-view-page">
      <header className="h-12 bg-white border-b border-[#181B34]/10 flex items-center px-4 gap-2">
        <span className="w-7 h-7 rounded-lg bg-[#6161FF] flex items-center justify-center"><Network size={15} className="text-white" /></span>
        <span className="font-display font-extrabold">Organa</span>
        <span className="text-sm font-semibold text-[#676a82] ml-2">{org_name} · {view.name}</span>
        <span className="ml-auto text-[10px] font-bold uppercase tracking-[0.2em] px-2.5 py-1 rounded-full bg-[#00C875]/15 text-[#00925a]">Read-only</span>
      </header>
      <div className="flex-1 relative overflow-hidden">
        {(layout === "classic" || layout === "horizontal" || layout === "radial") && (
          <ChartCanvas employees={employees} view={view} layout={layout} collapsed={collapsed}
            onToggle={onToggle} onSelect={() => {}} onMove={() => {}} canReparent={false} focusNode={null} />
        )}
        {layout === "outline" && <OutlineView employees={employees} view={view} onSelect={() => {}} focusNode={null} />}
        {layout === "team_grid" && <TeamGrid employees={employees} view={view} onSelect={() => {}} focusNode={null} />}
        <Legend employees={employees} colorConfig={view.color_config} />
      </div>
    </div>
  );
}
